import { cn } from '@ahm/common-helpers';
import './booking-layout.css';
import { useMapControl } from '@ahm/react-map/store';
import type { PropsWithChildren } from 'react';
import classes from './booking-layout.module.css';
import MapContainer from '@/components/map-container';

type Props = PropsWithChildren<{
  className?: string;
}>;

export default function BookingAside({ children, className }: Props) {
  const pinMap = useMapControl.use.pinMap();

  return (
    <>
      <style>
        {`.ahm__sBeXpED:root{--booking-layout-aside-width:calc(100% - var(--booking-layout-navbar-offset, 0px))}.ahm__sBeXpED [class^=&quot;booking-layout_detailsWrapper&quot;]{display:none}@media (min-width:768px){:root{--booking-layout-aside-width:calc(100% - 31.25rem - var(--booking-layout-navbar-offset, 0px));--booking-layout-aside-offset:var(--booking-layout-aside-width, 0px)}}`}
      </style>
      <div className={cn(classes.detailsWrapper, className)}>{children}</div>
      <aside
        className={cn('', classes.aside, {
          'z-[999]':
            typeof pinMap === 'number' &&
            Number.isInteger(pinMap) &&
            pinMap >= 0,
        })}
      >
        <MapContainer />
      </aside>
    </>
  );
}
